import type { MembershipRole } from '@services/auth.service';

export const ROLE_LABELS: Record<MembershipRole, string> = {
  OWNER: 'Owner',
  ADMIN: 'Admin',
  OPERATIONS_MANAGER: 'Operations Manager',
  DISPATCHER: 'Dispatcher',
  APPROVER: 'Approver',
  ACCOUNTING: 'Account Manager',
  DRIVER: 'Driver',
  VIEWER: 'Viewer',
};

export const ROLE_BADGE_STYLES: Record<MembershipRole, string> = {
  OWNER: 'bg-violet-100 text-violet-800 border-violet-200',
  ADMIN: 'bg-purple-100 text-purple-800 border-purple-200',
  OPERATIONS_MANAGER: 'bg-blue-100 text-blue-800 border-blue-200',
  DISPATCHER: 'bg-cyan-100 text-cyan-800 border-cyan-200',
  APPROVER: 'bg-indigo-100 text-indigo-800 border-indigo-200',
  ACCOUNTING: 'bg-amber-100 text-amber-900 border-amber-200',
  DRIVER: 'bg-emerald-100 text-emerald-800 border-emerald-200',
  VIEWER: 'bg-slate-100 text-slate-700 border-slate-200',
};

export function formatRole(role: MembershipRole | string | null | undefined): string {
  if (!role) return '—';
  return ROLE_LABELS[role as MembershipRole] ?? role;
}
